import "../css/about.css";

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";

export default function About() {
  useGSAP(() => {
    gsap.registerPlugin(ScrollTrigger);

    gsap.from(".about-img-wrapper", {
      scrollTrigger: {
        trigger: ".about-section",
        start: "top center",
      },
      opacity: 0,
      duration: 1.65,
      ease: "power3.out",
      y: 40,
    });

    gsap.from(".about-content", {
      scrollTrigger: {
        trigger: ".about-section",
        start: "top center",
      },
      opacity: 0,
      duration: 1.65,
      ease: "power3.out",
      delay: 1,
      y: 40,
    });
  });
  return (
    <section className="about-section" id="about">
      <div className="about-main-container">
        <div className="about-img-wrapper">
          <img src="/about.webp" alt="about-photo" />
        </div>
        <div className="about-content">
          <div className="about-text">
            <h2>Hilary Lawrence</h2>
            <h5>Attorney at Law</h5>
            <p>
              I am the mom of four sweet little girls, the spouse of a veteran,
              and a passionate estate planning attorney. I attended law school
              at Brigham Young University and Stanford Law School. I spend my
              free time enjoying the beautiful San Clemente beaches, playing
              piano, and dabbling in photography.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
